export const FETCH_SCENARIOS_OPTIONS = 'FETCH_SCENARIOS_OPTIONS';
export const FETCH_SCENARIO_CALC_DATA = 'FETCH_SCENARIO_CALC_DATA';
export const FETCH_COUNTRIES_FOR_SCENARIO = 'FETCH_COUNTRIES_FOR_SCENARIO';

export const FETCH_SCENARIO_MEMBERS_DATA = 'FETCH_SCENARIO_MEMBERS_DATA';
export const FETCH_SCENARIO_MEMBERS_DATA_SUCCESS = 'FETCH_SCENARIO_MEMBERS_DATA_SUCCESS';
export const FETCH_SCENARIO_MEMBERS_DATA_FAILURE = 'FETCH_SCENARIO_MEMBERS_DATA_FAILURE';

export const CLEAR_SCENARIO_MEMBERS_DATA = 'CLEAR_SCENARIO_MEMBERS_DATA';
